import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class SubGroupStore {
  vehicleSubgrpData = [];
  loading = false;
  assetList = [];
  vehicleArray = [];
  vehGrpData = [];
  groupVehicleList = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehicleSubgrpData: observable,
      loading: observable,
      vehicleArray: observable,
      vehGrpData: observable,
      groupVehicleList: observable,

      loadData: action,
      addData: action,
      getSubGroupData: action,
      deleteRecord: action,
      getGroupData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId }) {
    this.loading = true;

    var postData = { companyId: companyId, userId: null };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getSubGroupData", {
        params: postData,
      });

    this.vehicleSubgrpData =
      response?.data?.DeviceGroupData[0]?.deviceSubgroups;
    this.loading = false;
  }

  async getGroupData(companyId) {
    this.loading = true;

    var postData = { companyId: companyId, userId: null };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getDeviceGroup", {
        params: postData,
      });

    this.vehGrpData = response?.data?.DeviceGroupData[0]?.devicegroups;
    this.loading = false;
  }

  async getGroupVehiclesData(groupId) {
    this.loading = true;

    var postData = { groupId: groupId, userId: 1, isadmin: "-1" };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getGroupVehicles", {
        params: postData,
      });

    this.groupVehicleList = response?.data?.GroupVehicles;
    this.loading = false;
    return response?.data?.GroupVehicles;
  }

  async addData(postData) {
    var subGroupData = { postData };
    var response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/deviceGroup/updateDeviceSubGroups",
        subGroupData
      );

    return response;
  }
  //For Edit
  async getSubGroupData(deviceGroupId, companyId) {
    var postData = {
      deviceSubGroupId: deviceGroupId,
      limit: 1,
      offset: 0,
      companyId: companyId,
    };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getSubGroupData", {
        params: postData,
      });
    return response?.data?.DeviceGroupData[0]?.deviceSubgroups[0];
  }

  async deleteRecord({ deviceSubGroupId }) {
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + "/deviceGroup/deleteDeviceSubGroup", {
        params: {
          deviceSubGroupId: deviceSubGroupId,
        },
      });
    return response;
  }
}

export default SubGroupStore;
